class TeamPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'team.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'team._m';

    // Can access archived teams
    static ACCESS_ARCHIVE = 'team.access.archive';

    // Can create new team
    static CREATE = 'team.create';

    // Can update team info
    static INFO_UPDATE = 'team.info.update';

    // Can archive team
    static ARCHIVE = 'team.archive';

    // Can restore archived team
    static RESTORE = 'team.restore';

    // Can manage team participants
    static PARTICIPATION_MANAGE = 'team.participation.manage';
}

export default TeamPermission;
